import React, { memo } from 'react'
import tw from 'twin.macro'
import { ExternalSmallMinor } from '@shopify/polaris-icons'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { colors } from 'src/theme'
import { addS } from 'src/utils/baseUtils'

interface Props {
  text: string
  count: number
  targetId: string
  stateKey: string
  url: string
  className?: string
}

const NavigatorChipComponent = ({ text, count, targetId, stateKey, url, className }: Props) => {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(url, { state: { [stateKey]: targetId } })
  }

  return (
    <div
      css={[
        tw`flex items-center h-[20px] bg-[#F3F3F3] rounded-full pl-2 pr-1 cursor-pointer hover:bg-[#E8E8E8] transition-colors`,
        className,
      ]}
      onClick={handleClick}
    >
      <Typography variant="subtitle2" color={colors.SHADES_GREY_600}>
        {count} {addS(count, text)}
      </Typography>
      <ExternalSmallMinor fill={colors.SHADES_GREY_600} width={20} height={20} />
    </div>
  )
}

export const NavigatorChip = memo(NavigatorChipComponent)
